import styled from 'styled-components';
import { Checkbox } from 'antd';
import { IToken } from 'store/ducks/globalTypes';

interface IStyledCheckboxProps extends IToken {
  scheme?: string;
}

export const StyledCheckbox = styled(Checkbox)<IStyledCheckboxProps>`
  width: 10px;
  justify-content: center;

  .ant-checkbox-checked {
    &:after {
      border: unset;
    }

    .ant-checkbox-inner {
      background-color: ${(props) => {
        if (props.scheme === 'deepNavyTheme') return props.token.colorSuccess;
        return props.token.colorPrimary;
      }};
      border: 2px solid
        ${(props) => {
          if (props.scheme === 'deepNavyTheme') return props.token.colorSuccess;
          return props.token.colorPrimary;
        }} !important;
    }
  }

  .ant-checkbox-disabled .ant-checkbox-inner {
    background-color: white !important;
  }

  .ant-checkbox-inner {
    width: 21px;
    height: 21px;
    background: ${(props) => props.token.colorBgContainer};
    border: 2px solid ${(props) => props.token.colorBorder};

    &:after {
      width: 7px;
      height: 12px;
      border-color: ${(props) => props.token.colorWhite || '#ffffff'};
    }
  }

  &:not(.ant-checkbox-wrapper-disabled):hover
    .ant-checkbox-checked:not(.ant-checkbox-disabled):after {
    border: unset;
  }

  &:hover .ant-checkbox-inner {
    border-color: ${(props) => props.token.colorPrimary};
  }
`;
